module.exports = __webpack_public_path__ + "static/media/new_manager_qrcode1.7c04157e.png";